webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Goodbye__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_epl__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_nba_part__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_nhl__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello__["a" /* default */],
    Goodbye: __WEBPACK_IMPORTED_MODULE_1__components_Goodbye__["a" /* default */],
    vueSlider: __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default.a
  },
  data: function data() {
    // Parse data into a more barebones format. Move tall this logic to cloud function, probably
    var onlyPoints = [];
    var bgArray = [];
    var bgImage = [];
    for (var i = 0; i < this.data.length; i++) {
      onlyPoints.push(this.data[i].points);
      var color = {
        'backgroundColor': this.data[i].primary,
        'borderColor': this.data[i].primary,
        'padding': '2px 2px',
        'minHeight': '5px',
        'borderRadius': '50%'
      };
      var dot = {
        'backgroundImage': 'url("' + this.data[i].crest + '")',
        'backgroundSize': 'contain',
        'backgroundRepeat': 'no-repeat',
        'backgroundPosition': 'center',
        'backgroundColor': 'rgba(0,0,0,0)',
        'borderRadius': '0',
        'top': '-11px'
        // 'backgroundColor': this.data[i].primary,
        // 'borderColor': this.data[i].primary
      };
      bgImage.push(dot);
      bgArray.push(color);
    }

    var rounds = onlyPoints[0].length; // Set amount of rounds
    var values = Array.apply(null, Array(onlyPoints.length)).map(Number.prototype.valueOf, 0); // Create array of zeroes for initial state
    var max = Math.max.apply(null, onlyPoints.map(function (row) {
      return Math.max.apply(Math, row);
    })); // Find the max-value for points
    return {
      value: 0,
      speed: 3,
      values: values,
      rounds: rounds,
      teams: onlyPoints,
      data: this.data,
      league: this.league,
      sliderSettings: {
        min: 0,
        max: max,
        'tooltip-dir': 'left',
        'dot-size': 24
      },
      valueSliderSettings: {
        min: 0,
        max: rounds,
        'tooltip-dir': 'bottom'
      },
      speedSliderSettings: {
        min: 0,
        max: 6,
        'tooltip': 'false'
      },
      bgArray: bgArray,
      bgImage: bgImage,
      bg: {
        'backgroundColor': 'black',
        'borderColor': 'black'
      }
    };
  },

  methods: {
    setValue: function setValue(name, num) {
      this[name] = num;
    },
    play: function play(speed) {
      var _this = this;

      var interval = (speed - 0) * ((200 - 2000) / (6 - 0)) + 2000; // map speed to interval range
      console.log(interval);
      if (!this.playing) {
        console.log('hm');
        this.playing = setInterval(function () {
          var num = _this.value + 1;
          if (num <= _this.rounds) {
            _this.value = num;
          } else {
            _this.value = 0;
          }
        }, interval);
      }
    },
    pause: function pause() {
      clearInterval(this.playing);
      delete this.playing;
    },
    reset: function reset() {
      this.pause();
      this.value = 0;
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (newVal === 0) {
        this.values = this.teams.map(function (value, index) {
          return 0;
        });
      } else if (newVal <= this.rounds) {
        this.values = this.teams.map(function (value, index) {
          return value[newVal - 1];
        });
      }
    },
    speed: function speed(newVal, oldVal) {
      if (this.playing) {
        clearInterval(this.playing);
        delete this.playing;
        this.play(newVal);
      }
    }
  },
  beforeCreate: function beforeCreate() {
    var route = this.$route.path;
    if (route === '/' || route === '/epl') {
      console.log(this);
      this.data = __WEBPACK_IMPORTED_MODULE_3__data_epl__["a" /* default */];
      this.league = 'Premier League';
    } else if (route === '/nba') {
      this.data = __WEBPACK_IMPORTED_MODULE_4__data_nba_part__["a" /* default */];
      this.league = 'NBA';
    } else if (route === '/nhl') {
      this.data = __WEBPACK_IMPORTED_MODULE_5__data_nhl__["a" /* default */];
      this.league = 'NHL';
    } else {
      console.log('Oh noes :(');
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'site-title',
  props: ['title'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'site-credit',
  data: function data() {
    return {
      msg: 'Credit where credit is due:',
      content: 'football-data.org'
    };
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(11);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  path: '*',
  redirect: '/'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: router,
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0209f714_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(24);
function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0209f714_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103a2d15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(16);
function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103a2d15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-title"},[_c('h1',[_vm._v(_vm._s(_vm.title)+" animated")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Goodbye_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f66910e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Goodbye_vue__ = __webpack_require__(19);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Goodbye_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f66910e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Goodbye_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credits"},[_c('p'),_c('li',[_vm._v("Inspiration: "),_c('a',{attrs:{"href":"https://www.reddit.com/r/soccer/comments/84vos6/serie_a_table_animated/"}},[_vm._v("Serie A table animated by Itafan")])]),_vm._v(" "),_c('li',[_vm._v("Data: "),_c('a',{attrs:{"href":"https://football-data.org"}},[_vm._v("EPL | football-data.org")]),_vm._v(" & "),_c('a',{attrs:{"href":"http://statsapi.web.nhl.com/"}},[_vm._v("NHL | NHL Stats API")])]),_vm._v(" "),_c('li',[_vm._v("Team colors and logos: "),_c('a',{attrs:{"href":"https://teamcolorcodes.com/soccer/"}},[_vm._v("teamcolorcodes.com")]),_vm._v(" & "),_c('a',{attrs:{"href":"https://wikipedia.org"}},[_vm._v("wikipedia.org")])]),_vm._v(" "),_c('li',[_vm._v("Fork it on "),_c('a',{attrs:{"href":"https://github.com/KODHAGe/footybars"}},[_vm._v("Github")])]),_vm._v(" "),_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var eplData = [{
  team: 'Manchester City FC',
  crest: 'https://upload.wikimedia.org/wikipedia/en/e/eb/Manchester_City_FC_badge.svg',
  primary: '#99C5E7',
  secondary: '#022A5D',
  points: [3, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34, 37, 40, 43, 46, 49, 52, 55, 58, 59, 62, 62, 65, 68, 69, 72, 75, 78, 81]
}, {
  team: 'Manchester United FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/d/da/Manchester_United_FC.svg',
  primary: '#DC1F29',
  secondary: '#FAE935',
  points: [3, 6, 9, 10, 13, 16, 19, 20, 20, 23, 23, 26, 29, 32, 35, 35, 38, 41, 42, 43, 44, 47, 50, 53, 53, 56, 56, 59, 62, 65]
}, {
  team: 'Tottenham Hotspur FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/b/b4/Tottenham_Hotspur.svg',
  primary: '#11214B',
  secondary: '#FFFFFF',
  points: [3, 3, 4, 7, 8, 11, 14, 17, 20, 20, 23, 23, 24, 24, 25, 28, 31, 31, 34, 37, 38, 41, 44, 45, 48, 49, 52, 55, 58, 61]
}, {
  team: 'Liverpool FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/0/0a/FC_Liverpool.svg',
  primary: '#E0202C',
  secondary: '#19A78E',
  points: [1, 4, 7, 7, 8, 11, 12, 13, 13, 16, 19, 22, 23, 26, 29, 30, 31, 34, 35, 38, 41, 44, 47, 47, 50, 51, 54, 57, 60, 60]
}, {
  team: 'Chelsea FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/5/5c/Chelsea_crest.svg',
  primary: '#034694',
  secondary: '#DBA111',
  points: [0, 3, 6, 9, 10, 13, 13, 13, 16, 19, 22, 25, 26, 29, 32, 32, 35, 38, 39, 42, 45, 46, 47, 50, 50, 50, 53, 53, 53, 56]
}, {
  team: 'Arsenal FC',
  crest: 'http://upload.wikimedia.org/wikipedia/en/5/53/Arsenal_FC.svg',
  primary: '#EC0C1C',
  secondary: '#D80919',
  points: [3, 3, 3, 6, 7, 10, 13, 13, 16, 19, 19, 22, 25, 28, 28, 29, 30, 33, 34, 37, 38, 39, 39, 42, 42, 45, 45, 45, 45, 48]
}, {
  team: 'Burnley FC',
  crest: 'https://upload.wikimedia.org/wikipedia/en/0/02/Burnley_FC_badge.png',
  primary: '#80234C',
  secondary: '#91D2F2',
  points: [3, 3, 4, 7, 8, 9, 12, 13, 13, 16, 19, 22, 22, 25, 25, 28, 31, 32, 32, 33, 34, 34, 34, 34, 35, 36, 36, 37, 40, 43]
}, {
  team: 'Leicester City FC',
  crest: 'http://upload.wikimedia.org/wikipedia/en/6/63/Leicester02.png',
  primary: '#1358A1',
  secondary: '#FAB92C',
  points: [0, 3, 3, 3, 4, 4, 5, 6, 9, 12, 13, 13, 14, 17, 20, 23, 26, 26, 27, 27, 27, 30, 31, 34, 34, 35, 35, 36, 37, 40]
}, {
  team: 'Everton FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/f/f9/Everton_FC.svg',
  primary: '#063A99',
  secondary: '#FFFFFF',
  points: [3, 4, 4, 4, 4, 7, 7, 8, 8, 8, 11, 12, 12, 15, 18, 19, 22, 25, 26, 27, 27, 27, 27, 28, 31, 31, 34, 34, 34, 37]
}, {
  team: 'Watford FC',
  crest: 'https://upload.wikimedia.org/wikipedia/en/e/e2/Watford.svg',
  primary: '#FEEB00',
  secondary: '#E40F18',
  points: [1, 4, 5, 8, 8, 11, 12, 15, 15, 15, 15, 18, 21, 21, 22, 22, 22, 22, 22, 25, 25, 25, 26, 26, 27, 30, 30, 33, 36, 36]
}, {
  team: 'Brighton & Hove Albion',
  crest: 'https://upload.wikimedia.org/wikipedia/en/f/fd/Brighton_&_Hove_Albion_logo.svg',
  primary: '#0A56A3',
  secondary: '#F8BC1B',
  points: [0, 0, 1, 4, 4, 7, 7, 8, 11, 12, 15, 16, 16, 17, 17, 17, 17, 18, 21, 21, 22, 23, 23, 23, 24, 27, 28, 31, 34, 34]
}, {
  team: 'AFC Bournemouth',
  crest: 'https://upload.wikimedia.org/wikipedia/de/4/41/Afc_bournemouth.svg',
  primary: '#D41E2A',
  secondary: '#000000',
  points: [0, 0, 0, 0, 3, 3, 4, 4, 7, 7, 10, 13, 14, 14, 15, 16, 16, 16, 16, 17, 20, 21, 24, 25, 28, 31, 31, 32, 33, 33]
}, {
  team: 'Newcastle United FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/5/56/Newcastle_United_Logo.svg',
  primary: '#000000',
  secondary: '#FFFFFF',
  points: [0, 0, 3, 6, 9, 9, 10, 11, 14, 14, 14, 14, 14, 15, 15, 15, 15, 15, 18, 18, 19, 22, 23, 23, 24, 25, 28, 29, 29, 32]
}, {
  team: 'Swansea City FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/a/ab/Swansea_City_Logo.svg',
  primary: '#121212',
  secondary: '#FFFFFF',
  points: [1, 1, 4, 4, 5, 5, 5, 8, 8, 8, 8, 8, 9, 9, 9, 12, 12, 12, 13, 13, 16, 16, 17, 20, 23, 24, 27, 27, 30, 31]
}, {
  team: 'Huddersfield Town',
  crest: 'https://upload.wikimedia.org/wikipedia/en/5/5a/Huddersfield_Town_A.F.C._logo.svg',
  primary: '#0E63AD',
  secondary: '#FFFFFF',
  points: [3, 6, 7, 7, 8, 9, 9, 9, 12, 12, 15, 15, 15, 15, 15, 18, 18, 21, 22, 23, 24, 24, 24, 24, 24, 24, 27, 30, 30, 31]
}, {
  team: 'West Ham United FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/e/e0/West_Ham_United_FC.svg',
  primary: '#7A263A',
  secondary: '#1BB1E7',
  points: [0, 0, 0, 3, 4, 4, 7, 8, 8, 9, 9, 9, 10, 10, 10, 13, 14, 17, 17, 18, 19, 22, 25, 26, 27, 27, 30, 30, 30, 30]
}, {
  team: 'Southampton FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/c/c9/FC_Southampton.svg',
  primary: '#D41E29',
  secondary: '#FFC20E',
  points: [1, 4, 5, 5, 8, 8, 8, 9, 12, 13, 13, 13, 16, 16, 17, 18, 18, 18, 19, 19, 20, 20, 21, 22, 23, 26, 26, 27, 28, 28]
}, {
  team: 'Crystal Palace FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/b/bf/Crystal_Palace_F.C._logo_(2013).png',
  primary: '#1B458F',
  secondary: '#A7A5A6',
  points: [0, 0, 0, 0, 0, 0, 0, 3, 3, 4, 4, 5, 8, 9, 10, 11, 14, 17, 18, 18, 19, 22, 25, 25, 26, 27, 27, 27, 27, 27]
}, {
  team: 'Stoke City FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/a/a3/Stoke_City.svg',
  primary: '#D0122D',
  secondary: '#001F61',
  points: [0, 3, 4, 5, 5, 5, 8, 8, 8, 11, 12, 13, 13, 13, 16, 16, 16, 16, 19, 20, 20, 20, 20, 23, 24, 24, 25, 26, 27, 27]
}, {
  team: 'West Bromwich Albion FC',
  crest: 'http://upload.wikimedia.org/wikipedia/de/8/8b/West_Bromwich_Albion.svg',
  primary: '#122F67',
  secondary: '#FFFFFF',
  points: [3, 6, 7, 7, 8, 8, 9, 10, 10, 10, 10, 10, 11, 12, 13, 13, 14, 14, 14, 15, 16, 16, 19, 20, 20, 20, 20, 20, 20, 20]
}];
/* harmony default export */ __webpack_exports__["a"] = (eplData);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var nbaData = [{
  team: 'Houston Rockets',
  primary: '#CE1141',
  crest: 'https://upload.wikimedia.org/wikipedia/en/2/28/Houston_Rockets.svg',
  points: [1, 2, 2, 2, 3, 3, 3, 3, 4, 4, 5, 5, 5, 5, 5, 6, 6, 7, 7, 8, 8, 8, 8, 9, 9, 10, 11, 11, 11, 11, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 27, 27, 27, 27, 27, 28, 28, 29, 29, 30, 30, 30, 30, 30, 30, 31, 31, 32, 32, 33, 33, 34, 34, 34, 34, 35, 35, 36, 36, 37, 37, 38, 38, 38, 39, 40, 40, 41, 41, 42, 42, 43, 44, 44, 44, 44, 44, 44, 44, 44, 44, 45, 45, 46, 47, 47, 48, 48, 48, 49, 49, 49, 50, 51, 51, 51, 51, 52, 53, 53, 53, 54, 54, 55, 56, 56]
}, {
  team: 'Golden State Warriors',
  primary: '#006BB6',
  crest: 'https://upload.wikimedia.org/wikipedia/en/0/01/Golden_State_Warriors_logo.svg',
  points: [0, 0, 0, 1, 1, 1, 2, 2, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 9, 10, 10, 11, 11, 11, 11, 11, 12, 13, 13, 13, 13, 13, 14, 15, 15, 15, 15, 16, 16, 17, 17, 18, 19, 19, 20, 20, 21, 21, 21, 22, 22, 22, 23, 23, 23, 23, 24, 24, 25, 25, 26, 26, 26, 27, 27, 28, 28, 28, 29, 29, 29, 29, 30, 31, 31, 32, 32, 33, 33, 33, 33, 34, 35, 35, 36, 36, 37, 37, 37, 37, 37, 37, 38, 38, 39, 39, 40, 40, 40, 40, 40, 40, 41, 41, 41, 41, 41, 41, 42, 42, 43, 43, 44, 44, 44, 44, 44, 44, 44, 44, 44, 44, 45, 45, 46, 46, 47, 47, 48, 48, 49, 49, 49, 49, 50, 50, 51, 51, 51, 51, 51, 51, 52, 52, 52, 53, 53, 53, 53, 53, 53]
}, {
  team: 'Portland Trail Blazers',
  primary: '#E03A3E',
  crest: 'https://upload.wikimedia.org/wikipedia/en/2/21/Portland_Trail_Blazers_logo.svg',
  points: [0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 8, 8, 8, 9, 9, 10, 10, 10, 10, 11, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 21, 21, 22, 22, 22, 22, 22, 22, 22, 23, 23, 24, 24, 25, 25, 25, 25, 26, 26, 27, 27, 27, 27, 28, 29, 29, 29, 29, 29, 29, 29, 29, 30, 31, 31, 31, 31, 31, 32, 32, 32, 32, 32, 32, 32, 32, 32, 33, 34, 34, 34, 35, 35, 36, 36, 37, 37, 38, 39, 39, 39, 40, 40, 40, 41, 41, 41, 42, 42, 43, 44, 44]
}, {
  team: 'Oklahoma City Thunder',
  primary: '#EF3B24',
  crest: 'https://upload.wikimedia.org/wikipedia/en/5/5d/Oklahoma_City_Thunder.svg',
  points: [0, 0, 1, 1, 1, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 16, 16, 17, 18, 18, 19, 19, 20, 20, 20, 20, 20, 20, 20, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 24, 24, 25, 25, 25, 26, 26, 26, 27, 27, 28, 28, 29, 30, 30, 30, 30, 30, 30, 30, 30, 30, 31, 31, 31, 31, 31, 32, 32, 32, 33, 33, 33, 33, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 36, 36, 37, 37, 37, 37, 37, 37, 38, 38, 39, 39, 40, 41, 41, 41, 42, 42, 43, 43]
}, { team: 'Utah Jazz',
  primary: '#002B5C',
  crest: 'https://upload.wikimedia.org/wikipedia/en/0/04/Utah_Jazz_logo_%282016%29.svg',
  points: [0, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 3, 3, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 9, 9, 9, 10, 10, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 19, 19, 19, 19, 20, 20, 21, 21, 21, 21, 22, 22, 22, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 29, 29, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 31, 31, 31, 31, 31, 31, 32, 33, 33, 34, 34, 35, 35, 36, 36, 37, 37, 38, 38, 39, 39, 40, 40, 40]
}, { team: 'New Orleans Pelicans',
  primary: '#002B5C',
  crest: 'https://upload.wikimedia.org/wikipedia/en/0/0d/New_Orleans_Pelicans_logo.svg',
  points: [0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 3, 3, 3, 3, 3, 3, 4, 5, 5, 5, 6, 6, 6, 6, 7, 7, 8, 8, 8, 8, 8, 8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 16, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 22, 22, 23, 23, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 27, 27, 27, 27, 27, 28, 28, 28, 28, 28, 28, 28, 28, 29, 29, 30, 30, 31, 31, 31, 31, 31, 31, 31, 31, 31, 32, 32, 33, 34, 34, 35, 35, 35, 35, 36, 36, 37, 38, 38, 38, 38, 38, 38, 39, 39, 39, 39, 39, 40, 40]
}, { team: 'San Antonio Spurs',
  primary: '#000000',
  crest: 'https://upload.wikimedia.org/wikipedia/en/a/a2/San_Antonio_Spurs.svg',
  points: [0, 1, 1, 1, 2, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 6, 6, 7, 7, 7, 7, 8, 8, 8, 9, 9, 9, 10, 10, 10, 11, 11, 11, 11, 11, 12, 12, 13, 13, 14, 14, 15, 15, 15, 16, 16, 17, 17, 18, 19, 19, 19, 19, 19, 19, 19, 20, 20, 21, 21, 22, 22, 22, 23, 23, 23, 24, 24, 25, 25, 25, 25, 25, 26, 26, 26, 27, 27, 27, 28, 28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 30, 30, 31, 32, 32, 32, 32, 33, 33, 34, 34, 34, 34, 34, 34, 34, 34, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 36, 36, 36, 36, 36, 36, 36, 36, 37, 37, 37, 37, 37, 37, 37, 37, 38, 38, 39, 39, 40, 40, 41, 41]
}, { team: 'Minnesota Timberwolves',
  primary: '#0C2340',
  crest: 'https://upload.wikimedia.org/wikipedia/en/c/c2/Minnesota_Timberwolves_logo.svg',
  points: [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 3, 3, 3, 4, 4, 5, 5, 5, 6, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 9, 9, 10, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 19, 19, 19, 20, 20, 21, 21, 22, 22, 22, 22, 23, 24, 24, 24, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 29, 29, 29, 29, 30, 30, 31, 31, 31, 31, 31, 32, 32, 32, 32, 32, 33, 33, 34, 34, 34, 34, 34, 34, 34, 34, 35, 35, 35, 35, 36, 36, 36, 36, 36, 36, 36, 36, 36, 37, 37, 38, 38, 38, 38, 38, 38, 38, 38, 38, 38, 38, 38, 38, 39, 39, 40, 40, 40, 40, 40, 40, 40]
}, { team: 'Denver Nuggets',
  primary: '#FDB927',
  crest: 'https://upload.wikimedia.org/wikipedia/en/7/76/Denver_Nuggets.svg',
  points: [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 2, 2, 3, 3, 3, 4, 4, 5, 5, 5, 5, 6, 6, 7, 7, 8, 8, 8, 8, 8, 8, 9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 12, 12, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 16, 16, 16, 16, 16, 16, 16, 17, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 24, 24, 24, 25, 25, 26, 26, 26, 26, 26, 27, 27, 28, 28, 29, 29, 29, 29, 29, 30, 30, 30, 31, 31, 32, 32, 32, 32, 32, 32, 32, 32, 33, 33, 33, 33, 33, 33, 33, 34, 35, 35, 35, 35, 35, 35, 36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 38, 38]
}, { team: 'Los Angeles Clippers',
  primary: '#ED174C',
  crest: 'https://upload.wikimedia.org/wikipedia/en/b/bb/Los_Angeles_Clippers_%282015%29.svg',
  points: [0, 0, 1, 1, 2, 2, 2, 3, 3, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 11, 11, 11, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16, 17, 17, 17, 17, 17, 17, 18, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 25, 25, 25, 25, 25, 25, 26, 26, 27, 27, 27, 27, 28, 28, 28, 29, 29, 30, 30, 30, 30, 30, 30, 30, 30, 30, 31, 31, 31, 31, 32, 32, 32, 33, 33, 34, 34, 34, 34, 34, 35, 36, 36, 36, 37, 37, 37, 37, 37, 37, 37]
}, { team: 'Los Angeles Lakers',
  primary: '#552583',
  crest: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Los_Angeles_Lakers_logo.svg',
  points: [0, 0, 0, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 3, 3, 3, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 15, 15, 16, 16, 17, 17, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 25, 25, 26, 26, 26, 27, 27, 28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 31, 31, 31, 31, 31, 31, 31, 31, 31]
}, { team: 'Sacramento Kings',
  primary: '#5A2B81',
  crest: 'https://upload.wikimedia.org/wikipedia/en/c/c7/SacramentoKings.svg',
  points: [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 10, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 15, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 22, 22, 23, 23, 23, 23, 23, 23]
}, { team: 'Dallas Mavericks',
  primary: '#0053BC',
  crest: 'https://upload.wikimedia.org/wikipedia/en/9/97/Dallas_Mavericks_logo.svg',
  points: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 10, 11, 11, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22]
}, { team: 'Memphis Grizzlies',
  primary: '#00285E',
  crest: 'https://upload.wikimedia.org/wikipedia/en/f/f1/Memphis_Grizzlies.svg',
  points: [0, 1, 1, 1, 2, 2, 3, 3, 3, 4, 4, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 14, 14, 15, 15, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19]
}, { team: 'Phoenix Suns',
  primary: '#E56020',
  crest: 'https://upload.wikimedia.org/wikipedia/en/d/dc/Phoenix_Suns_logo.svg',
  points: [0, 0, 0, 0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19]
}];

/* harmony default export */ __webpack_exports__["a"] = (nbaData);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var nhlData = [{
  'team': 'Nashville Predators',
  'points': [0, 0, 2, 4, 5, 7, 9, 9, 10, 12, 12, 12, 14, 16, 18, 20, 22, 22, 24, 26, 28, 30, 31, 33, 33, 35, 37, 39, 40, 42, 44, 46, 46, 46, 47, 49, 49, 51, 51, 52, 54, 56, 58, 60, 62, 63, 65, 65, 67, 69, 71, 72, 73, 75, 77, 77, 77, 79, 81, 83, 85, 87, 89, 91, 93, 95, 97, 98, 100, 102, 104, 106, 106, 106, 107, 109, 111, 111, 113, 113, 115, 117],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Nashville Predators Logo (2011).svg',
  'primary': '#FFB81C',
  'secondary': '#041E42'
}, {
  'team': 'Winnipeg Jets',
  'points': [0, 0, 2, 4, 6, 6, 8, 9, 10, 12, 14, 16, 17, 19, 19, 21, 23, 25, 27, 27, 29, 31, 31, 33, 34, 36, 38, 38, 38, 39, 41, 41, 41, 43, 45, 46, 46, 48, 50, 52, 53, 55, 57, 59, 59, 59, 61, 63, 65, 66, 68, 69, 71, 73, 73, 73, 75, 77, 79, 79, 81, 83, 83, 85, 87, 89, 91, 91, 92, 92, 94, 96, 98, 100, 102, 104, 104, 106, 108, 110, 112, 114],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Winnipeg Jets Logo 2011.svg',
  'primary': '#041E41',
  'secondary': '#0060A5'
}, {
  'team': 'Tampa Bay Lightning',
  'points': [2, 2, 4, 6, 8, 10, 11, 13, 15, 17, 19, 19, 21, 22, 24, 26, 28, 30, 32, 32, 34, 34, 34, 36, 36, 38, 40, 42, 44, 46, 48, 50, 50, 52, 54, 56, 56, 58, 60, 61, 61, 63, 65, 65, 65, 65, 67, 69, 71, 71, 73, 75, 75, 77, 79, 79, 79, 81, 81, 83, 85, 87, 89, 90, 92, 94, 96, 98, 100, 100, 100, 102, 104, 106, 106, 106, 106, 108, 108, 110, 112, 113],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Tampa Bay Lightning Logo 2011.svg',
  'primary': '#00205B',
  'secondary': '#FFFFFF'
}, {
  'team': 'Boston Bruins',
  'points': [2, 2, 2, 4, 4, 6, 7, 9, 10, 11, 13, 13, 15, 15, 16, 16, 16, 18, 20, 22, 24, 24, 26, 28, 28, 30, 32, 34, 34, 35, 37, 39, 41, 43, 45, 46, 48, 50, 52, 53, 55, 56, 58, 60, 62, 64, 66, 66, 68, 70, 72, 74, 74, 76, 78, 78, 80, 82, 82, 82, 84, 86, 88, 90, 92, 94, 94, 96, 96, 98, 99, 100, 102, 104, 105, 107, 109, 110, 110, 110, 112, 112],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Boston Bruins.svg',
  'primary': '#111111',
  'secondary': '#FCB514'
}, {
  'team': 'Vegas Golden Knights',
  'points': [2, 4, 6, 6, 8, 10, 12, 14, 16, 16, 16, 16, 18, 19, 19, 21, 21, 23, 25, 27, 29, 31, 31, 31, 31, 33, 35, 37, 39, 40, 42, 44, 46, 48, 50, 52, 54, 56, 56, 58, 60, 61, 61, 63, 64, 66, 68, 68, 70, 72, 72, 74, 74, 76, 76, 78, 80, 82, 82, 84, 86, 87, 87, 87, 89, 89, 91, 93, 95, 95, 95, 97, 99, 100, 101, 103, 103, 105, 107, 109, 109, 109],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Vegas Golden Knights logo.svg',
  'primary': '#333F42',
  'secondary': '#B4975A'
}, {
  'team': 'Washington Capitals',
  'points': [2, 4, 5, 5, 7, 7, 7, 9, 9, 9, 11, 11, 13, 15, 17, 17, 19, 21, 21, 21, 23, 23, 25, 27, 29, 29, 31, 33, 35, 37, 37, 39, 41, 43, 45, 46, 46, 47, 49, 51, 53, 55, 57, 57, 59, 60, 60, 61, 63, 65, 65, 65, 67, 69, 70, 71, 73, 73, 75, 75, 75, 77, 77, 79, 81, 81, 81, 83, 85, 87, 89, 89, 91, 93, 95, 97, 99, 99, 101, 103, 103, 105],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Washington Capitals.svg',
  'primary': '#CF0A2C',
  'secondary': '#FFFFFF'
}, {
  'team': 'Toronto Maple Leafs',
  'points': [2, 4, 6, 6, 8, 10, 12, 12, 14, 14, 14, 14, 16, 16, 16, 18, 20, 22, 24, 26, 28, 28, 29, 31, 31, 33, 35, 35, 37, 39, 41, 41, 41, 41, 43, 43, 45, 47, 48, 48, 48, 50, 52, 53, 53, 54, 55, 57, 57, 59, 61, 63, 65, 65, 67, 69, 71, 73, 75, 75, 77, 79, 81, 83, 84, 85, 85, 85, 87, 89, 91, 93, 93, 95, 97, 97, 99, 101, 101, 103, 103, 105],
  'matchesLeft': 1,
  'primary': '#002868',
  'secondary': '#FFFFFF',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Toronto Maple Leafs 2016 logo.svg'
}, {
  'team': 'Anaheim Ducks',
  'points': [2, 3, 3, 5, 5, 5, 7, 9, 9, 11, 13, 13, 13, 14, 15, 17, 17, 19, 21, 23, 23, 23, 24, 24, 26, 26, 27, 28, 30, 31, 33, 35, 36, 36, 36, 38, 40, 40, 42, 44, 46, 47, 47, 49, 49, 51, 53, 53, 55, 57, 59, 60, 60, 60, 62, 64, 65, 65, 67, 69, 71, 73, 73, 74, 76, 78, 80, 80, 80, 80, 82, 84, 86, 88, 89, 91, 91, 93, 95, 97, 99, 101],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Anaheim_Ducks.svg',
  'primary': '#111111',
  'secondary': '#B5985A'
}, {
  'team': 'Minnesota Wild',
  'points': [0, 1, 3, 4, 4, 6, 6, 8, 10, 10, 12, 12, 12, 12, 14, 16, 18, 20, 20, 21, 23, 25, 25, 25, 27, 29, 29, 31, 33, 35, 37, 37, 37, 39, 39, 39, 41, 43, 43, 45, 47, 47, 48, 50, 52, 53, 55, 57, 57, 59, 61, 61, 63, 64, 66, 68, 68, 69, 71, 73, 75, 77, 79, 79, 79, 81, 83, 85, 85, 85, 87, 89, 90, 92, 93, 94, 96, 96, 98, 98, 99, 101],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Minnesota Wild.svg',
  'primary': '#AF1E24',
  'secondary': '#024930'
}, {
  'team': 'Pittsburgh Penguins',
  'points': [1, 1, 3, 5, 5, 7, 9, 11, 11, 13, 15, 15, 15, 17, 18, 18, 20, 20, 21, 23, 25, 25, 25, 25, 27, 29, 31, 33, 33, 35, 35, 35, 35, 37, 37, 39, 39, 41, 41, 41, 43, 43, 45, 47, 49, 51, 51, 53, 53, 55, 57, 59, 61, 61, 63, 64, 66, 68, 70, 72, 74, 76, 76, 76, 76, 78, 80, 82, 82, 84, 85, 87, 87, 89, 90, 92, 92, 94, 96, 96, 98, 100],
  'matchesLeft': 1,
  'primary': '#000000',
  'secondary': '#FCB514',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Pittsburgh Penguins logo (2016).svg'
}, {
  'team': 'San Jose Sharks',
  'points': [0, 0, 2, 2, 4, 6, 6, 8, 8, 10, 12, 14, 16, 16, 18, 20, 20, 20, 21, 23, 24, 26, 28, 30, 30, 30, 32, 34, 35, 37, 38, 38, 40, 42, 44, 44, 46, 47, 48, 48, 50, 52, 54, 54, 56, 58, 59, 59, 59, 60, 62, 64, 64, 64, 66, 68, 68, 70, 72, 74, 74, 74, 75, 77, 79, 79, 81, 81, 83, 85, 87, 89, 91, 93, 95, 97, 98, 98, 98, 98, 100, 100],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/SanJoseSharksLogo.svg',
  'primary': '#006D75',
  'secondary': '#EA7200'
}, {
  'team': 'Philadelphia Flyers',
  'points': [2, 2, 4, 4, 6, 8, 8, 10, 10, 10, 12, 13, 13, 15, 16, 18, 18, 18, 19, 20, 20, 21, 22, 23, 23, 23, 25, 27, 29, 31, 33, 35, 35, 37, 37, 38, 38, 40, 40, 42, 44, 46, 48, 48, 50, 52, 54, 56, 56, 56, 56, 57, 59, 61, 63, 65, 66, 68, 70, 72, 74, 76, 78, 78, 79, 79, 79, 79, 81, 81, 81, 83, 85, 86, 88, 89, 90, 92, 94, 94, 96, 98],
  'matchesLeft': 1,
  'primary': '#F74902',
  'secondary': '#000000',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Philadelphia Flyers.svg'
}, {
  'team': 'Los Angeles Kings',
  'points': [2, 4, 5, 7, 9, 11, 13, 13, 15, 17, 19, 19, 21, 22, 24, 24, 24, 24, 24, 26, 26, 26, 27, 29, 31, 33, 35, 37, 39, 41, 43, 43, 43, 44, 46, 48, 48, 49, 51, 53, 53, 53, 53, 53, 53, 53, 55, 55, 57, 59, 59, 61, 63, 65, 65, 65, 65, 67, 69, 71, 71, 71, 73, 75, 77, 77, 79, 79, 81, 82, 84, 84, 86, 87, 89, 89, 91, 93, 94, 96, 98, 98],
  'matchesLeft': 1,
  'primary': '#ACAEA9',
  'secondary': '#111111',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Los Angeles Kings Logo (2011).svg'
}, {
  'team': 'Columbus Blue Jackets',
  'points': [2, 2, 4, 6, 8, 10, 10, 10, 12, 14, 14, 16, 18, 19, 19, 19, 19, 21, 23, 25, 27, 29, 31, 31, 33, 35, 35, 35, 37, 39, 39, 41, 41, 41, 43, 44, 46, 47, 47, 47, 49, 49, 51, 53, 53, 53, 55, 55, 57, 58, 58, 58, 58, 58, 60, 62, 62, 63, 63, 65, 65, 67, 69, 69, 69, 71, 73, 75, 77, 79, 81, 83, 85, 87, 89, 89, 91, 93, 94, 96, 97, 97],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Columbus Blue Jackets logo.svg',
  'primary': '#002654',
  'secondary': '#CE1126'
}, {
  'team': 'New Jersey Devils',
  'points': [2, 4, 6, 6, 8, 10, 12, 12, 14, 16, 18, 18, 19, 19, 20, 22, 24, 25, 25, 27, 28, 30, 32, 32, 34, 34, 36, 36, 36, 38, 39, 41, 43, 45, 47, 49, 50, 50, 51, 51, 52, 52, 54, 56, 56, 56, 56, 56, 58, 60, 62, 62, 62, 62, 62, 64, 66, 68, 70, 70, 70, 72, 74, 74, 74, 74, 76, 76, 78, 80, 82, 82, 82, 84, 86, 88, 89, 91, 93, 95, 97, 97],
  'matchesLeft': 1,
  'primary': '#CE1126',
  'secondary': '#000000',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/New Jersey Devils logo.svg'
}, {
  'team': 'Florida Panthers',
  'points': [0, 2, 4, 4, 4, 4, 6, 6, 8, 9, 9, 9, 10, 10, 12, 12, 14, 16, 16, 16, 18, 18, 20, 22, 22, 23, 24, 26, 26, 28, 29, 29, 29, 31, 33, 35, 37, 39, 39, 39, 40, 42, 42, 44, 44, 44, 44, 46, 48, 50, 52, 52, 54, 56, 58, 58, 58, 60, 62, 64, 66, 68, 70, 71, 73, 75, 75, 77, 77, 79, 81, 81, 83, 85, 85, 86, 86, 88, 90, 92, 94, 96],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Florida Panthers 2016 logo.svg',
  'primary': '#C8102E',
  'secondary': '#041E42'
}, {
  'team': 'Colorado Avalanche',
  'points': [2, 2, 4, 6, 8, 8, 8, 8, 10, 10, 12, 14, 16, 16, 17, 17, 19, 19, 21, 23, 24, 24, 26, 26, 26, 26, 26, 28, 30, 30, 32, 32, 34, 35, 37, 37, 39, 41, 43, 45, 47, 49, 51, 53, 55, 57, 57, 57, 58, 60, 60, 62, 62, 62, 64, 66, 66, 66, 68, 69, 69, 71, 73, 75, 76, 77, 78, 80, 82, 84, 84, 86, 88, 88, 90, 90, 90, 92, 93, 93, 93, 95],
  'matchesLeft': 1,
  'primary': '#6F263D',
  'secondary': '#236192',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Colorado Avalanche logo.svg'
}, {
  'team': 'St. Louis Blues',
  'points': [2, 4, 6, 8, 8, 8, 10, 12, 13, 15, 17, 19, 21, 21, 23, 25, 27, 27, 27, 29, 31, 33, 33, 35, 35, 35, 36, 38, 40, 42, 44, 44, 44, 46, 46, 46, 46, 48, 48, 48, 50, 52, 54, 54, 55, 55, 57, 59, 59, 61, 63, 65, 65, 67, 67, 69, 71, 71, 72, 72, 72, 72, 72, 72, 74, 75, 75, 77, 79, 79, 81, 83, 85, 87, 89, 91, 92, 92, 92, 92, 94, 94],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/St. Louis Blues logo.svg',
  'primary': '#002F87',
  'secondary': '#FCB514'
}, {
  'team': 'Dallas Stars',
  'points': [0, 0, 2, 2, 4, 6, 8, 10, 10, 10, 12, 14, 14, 16, 16, 18, 18, 19, 19, 21, 23, 23, 25, 27, 29, 31, 33, 33, 33, 33, 35, 37, 37, 38, 39, 41, 43, 43, 45, 47, 47, 49, 51, 51, 53, 55, 56, 58, 60, 60, 60, 62, 64, 66, 68, 70, 70, 72, 72, 72, 74, 74, 76, 77, 79, 80, 80, 82, 82, 82, 83, 84, 84, 84, 84, 84, 86, 86, 88, 90, 90, 92],
  'matchesLeft': 1,
  'primary': '#006847',
  'secondary': '#111111',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Dallas Stars logo (2013).svg'
}, {
  'team': 'Calgary Flames',
  'points': [0, 2, 4, 6, 6, 8, 8, 8, 10, 10, 10, 12, 14, 16, 16, 18, 20, 20, 22, 24, 25, 25, 27, 27, 29, 29, 29, 30, 32, 34, 35, 35, 35, 37, 39, 39, 40, 40, 42, 44, 46, 48, 50, 52, 54, 55, 56, 57, 58, 58, 58, 60, 62, 64, 64, 66, 66, 68, 68, 69, 69, 71, 73, 73, 73, 73, 74, 76, 78, 78, 80, 80, 80, 80, 80, 80, 80, 80, 82, 82, 82, 84],
  'matchesLeft': 1,
  'primary': '#CE1126',
  'secondary': '#F3BC52',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Calgary Flames Logo.svg'
}, {
  'team': 'Carolina Hurricanes',
  'points': [2, 3, 3, 5, 7, 7, 7, 9, 9, 10, 10, 11, 13, 15, 16, 18, 18, 20, 22, 22, 22, 24, 25, 25, 27, 27, 28, 29, 29, 31, 33, 35, 35, 37, 39, 41, 43, 43, 44, 46, 46, 46, 48, 48, 48, 50, 50, 50, 52, 54, 56, 56, 56, 57, 59, 61, 63, 63, 63, 64, 64, 64, 65, 67, 69, 69, 69, 71, 71, 71, 71, 73, 73, 75, 77, 79, 79, 81, 81, 81, 81, 83],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Carolina Hurricanes.svg',
  'primary': '#CC0000',
  'secondary': '#FFFFFF'
}, {
  'team': 'New York Islanders',
  'points': [0, 2, 3, 3, 5, 5, 7, 9, 11, 11, 13, 15, 15, 17, 18, 18, 20, 22, 24, 24, 26, 28, 30, 32, 32, 34, 34, 35, 35, 37, 37, 37, 39, 39, 40, 42, 44, 44, 44, 44, 44, 44, 46, 48, 50, 50, 50, 52, 53, 55, 55, 55, 57, 58, 58, 60, 60, 60, 62, 64, 64, 65, 65, 65, 65, 66, 67, 68, 70, 70, 70, 70, 72, 72, 72, 72, 74, 74, 74, 76, 78, 80],
  'matchesLeft': 1,
  'primary': '#00539B',
  'secondary': '#F47D30',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Logo New York Islanders.svg'
}, {
  'team': 'Edmonton Oilers',
  'points': [2, 2, 2, 2, 2, 4, 4, 5, 7, 7, 7, 9, 9, 11, 13, 13, 14, 16, 16, 16, 16, 18, 18, 20, 22, 22, 24, 24, 26, 26, 28, 28, 30, 32, 34, 36, 36, 37, 37, 37, 39, 39, 39, 39, 41, 43, 45, 45, 47, 48, 50, 50, 50, 50, 50, 50, 50, 52, 52, 54, 56, 58, 58, 58, 58, 60, 62, 64, 64, 65, 67, 67, 69, 71, 73, 74, 74, 74, 74, 74, 76, 78],
  'matchesLeft': 1,
  'primary': '#FF4C00',
  'secondary': '#041E41',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Logo Edmonton Oilers.svg'
}, {
  'team': 'New York Rangers',
  'points': [0, 0, 2, 2, 2, 2, 3, 4, 6, 6, 8, 8, 10, 12, 14, 16, 18, 20, 20, 20, 22, 24, 26, 28, 28, 30, 32, 32, 34, 35, 35, 37, 39, 41, 42, 42, 44, 45, 47, 47, 49, 49, 49, 49, 51, 53, 53, 53, 53, 55, 55, 55, 55, 55, 57, 59, 59, 59, 59, 59, 59, 59, 60, 62, 64, 66, 66, 66, 67, 69, 71, 72, 72, 72, 74, 74, 75, 75, 77, 77, 77, 77],
  'matchesLeft': 1,
  'primary': '#0038A8',
  'secondary': '#CE1126',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/New York Rangers.svg'
}, {
  'team': 'Chicago Blackhawks',
  'points': [2, 4, 5, 7, 7, 9, 9, 10, 12, 12, 12, 12, 14, 16, 16, 16, 18, 18, 20, 22, 23, 25, 27, 27, 28, 29, 29, 29, 31, 33, 35, 37, 39, 39, 39, 39, 41, 42, 44, 44, 46, 48, 48, 50, 50, 50, 50, 51, 53, 55, 55, 56, 56, 56, 56, 56, 56, 56, 58, 58, 60, 62, 62, 62, 64, 64, 66, 66, 66, 68, 68, 68, 69, 69, 69, 71, 72, 74, 74, 76, 76, 76],
  'matchesLeft': 1,
  'primary': '#CF0A2C',
  'secondary': '#FFFFFF',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Chicago Blackhawks logo.svg'
}, {
  'team': 'Vancouver Canucks',
  'points': [2, 3, 3, 3, 5, 5, 7, 9, 11, 13, 14, 14, 16, 16, 18, 18, 18, 20, 20, 21, 23, 25, 25, 26, 26, 28, 30, 32, 32, 32, 32, 32, 34, 34, 34, 35, 35, 37, 37, 37, 38, 38, 38, 40, 42, 42, 42, 44, 44, 46, 48, 48, 48, 48, 48, 50, 50, 50, 52, 53, 53, 55, 55, 56, 57, 59, 59, 59, 59, 59, 59, 59, 59, 61, 61, 63, 65, 67, 69, 70, 72, 73],
  'matchesLeft': 1,
  'primary': '#001F5B',
  'secondary': '#008852',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Vancouver Canucks logo.svg'
}, {
  'team': 'Detroit Red Wings',
  'points': [2, 4, 4, 6, 8, 8, 8, 9, 9, 9, 9, 11, 13, 13, 15, 17, 17, 18, 20, 22, 23, 23, 24, 25, 25, 25, 25, 27, 27, 28, 29, 31, 33, 33, 33, 33, 35, 37, 39, 41, 41, 41, 43, 43, 43, 45, 46, 46, 48, 50, 50, 50, 51, 53, 55, 55, 57, 57, 57, 58, 60, 62, 62, 62, 62, 63, 63, 63, 63, 63, 63, 63, 65, 65, 65, 65, 67, 69, 71, 72, 72, 73],
  'matchesLeft': 1,
  'primary': '#CE1126',
  'secondary': '#FFFFFF',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Detroit Red Wings logo.svg'
}, {
  'team': 'Montreal Canadiens',
  'points': [2, 2, 2, 2, 3, 3, 3, 3, 5, 5, 7, 9, 9, 11, 13, 15, 15, 17, 18, 18, 18, 18, 19, 21, 23, 25, 27, 29, 29, 30, 30, 32, 32, 34, 36, 36, 36, 36, 36, 36, 38, 40, 41, 42, 42, 44, 44, 46, 46, 46, 46, 48, 50, 50, 51, 51, 51, 51, 52, 54, 55, 56, 58, 60, 61, 61, 61, 62, 62, 64, 64, 64, 64, 64, 66, 66, 68, 68, 68, 69, 71, 71],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Montreal Canadiens.svg',
  'primary': '#AF1E2D',
  'secondary': '#FFFFFF'
}, {
  'team': 'Arizona Coyotes',
  'points': [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 3, 3, 5, 6, 6, 7, 7, 7, 9, 11, 13, 13, 15, 15, 16, 16, 18, 19, 19, 19, 19, 19, 19, 19, 21, 21, 23, 23, 23, 25, 26, 26, 27, 28, 29, 31, 33, 33, 33, 33, 33, 35, 36, 38, 40, 42, 44, 44, 46, 46, 48, 50, 51, 53, 53, 55, 57, 57, 57, 59, 61, 61, 61, 63, 65, 65, 67, 69, 70, 70],
  'matchesLeft': 1,
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Arizona Coyotes.svg',
  'primary': '#8C2633',
  'secondary': '#E2D6B5'
}, {
  'team': 'Ottawa Senators',
  'points': [1, 2, 4, 6, 8, 8, 9, 11, 12, 14, 15, 15, 17, 17, 19, 21, 21, 22, 22, 22, 22, 22, 22, 24, 24, 24, 25, 25, 25, 27, 29, 29, 30, 30, 30, 32, 32, 33, 35, 37, 37, 39, 39, 39, 39, 39, 39, 39, 41, 43, 43, 45, 47, 47, 47, 49, 51, 51, 52, 52, 52, 52, 54, 54, 56, 57, 57, 59, 61, 63, 63, 63, 63, 63, 63, 63, 65, 65, 65, 67, 67, 67],
  'matchesLeft': 1,
  'primary': '#CE1126',
  'secondary': '#000000',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Ottawa Senators.svg'
}, {
  'team': 'Buffalo Sabres',
  'points': [1, 1, 1, 1, 1, 3, 4, 4, 6, 8, 8, 8, 10, 10, 12, 12, 13, 14, 14, 14, 14, 14, 16, 16, 16, 16, 16, 18, 19, 20, 22, 22, 23, 23, 25, 25, 26, 28, 29, 29, 29, 29, 29, 31, 31, 31, 33, 35, 37, 37, 37, 37, 38, 40, 42, 42, 44, 45, 45, 45, 47, 47, 49, 51, 51, 53, 53, 55, 56, 56, 58, 58, 58, 58, 58, 60, 60, 62, 62, 62, 62, 62],
  'matchesLeft': 1,
  'primary': '#002654',
  'secondary': '#FCB514',
  'crest': 'https://en.wikipedia.org/wiki/Special:Redirect/file/Buffalo Sabres Logo.svg'
}];

/* harmony default export */ __webpack_exports__["a"] = (nhlData);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('hello',{attrs:{"title":_vm.league}}),_vm._v(" "),_c('div',{staticClass:"bars"},_vm._l((_vm.values),function(value,index){return _c('div',{staticClass:"team"},[_c('h5',{staticClass:"team-title"},[_vm._v(_vm._s(index + 1)+". "+_vm._s(_vm.data[index].team))]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"slider",refInFor:true,class:['obj-' + index],attrs:{"processStyle":_vm.bgArray[index],"sliderStyle":_vm.bgImage[index],"tooltipStyle":_vm.bgArray[index]},model:{value:(_vm.values[index]),callback:function ($$v) {_vm.$set(_vm.values, index, $$v)},expression:"values[index]"}},'vue-slider',_vm.sliderSettings,false))],1)})),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"control-play"},[_c('button',{staticClass:"control-button",on:{"click":function($event){_vm.play(_vm.speed)}}},[_vm._v("Play")]),_vm._v(" "),_c('button',{staticClass:"control-button",on:{"click":function($event){_vm.pause()}}},[_vm._v("Pause")]),_vm._v(" "),_c('button',{staticClass:"control-button",on:{"click":function($event){_vm.reset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"control-speed"},[_c('h5',{staticClass:"control-label"},[_vm._v("Animation speed:")]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"slider",staticClass:"control-speed-slider",attrs:{"processStyle":_vm.bg,"tooltipStyle":_vm.bg},model:{value:(_vm.speed),callback:function ($$v) {_vm.speed=$$v},expression:"speed"}},'vue-slider',_vm.speedSliderSettings,false))],1),_vm._v(" "),_c('h5',{staticClass:"control-label"},[_vm._v("Games played:")]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"slider",staticClass:"control-slider",attrs:{"processStyle":_vm.bg,"tooltipStyle":_vm.bg},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'vue-slider',_vm.valueSliderSettings,false))],1),_vm._v(" "),_c('goodbye')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.6bb828d197ecab2e9a68.js